import { RegistrationCommonInputProps } from 'features/registration/interface/registration';
import { FC, useState } from 'react';
import ErrorCard from 'shared/components/dialog/errorCard';
import SuccessCard from 'shared/components/dialog/successCard';
import SendCode from 'shared/components/form/sendCode';
import SeparateNumericInputField from 'shared/components/form/SeparateNumericInputField';

type DialogType = '' | 'error' | 'smsSent';

const RegistrationStep7: FC<RegistrationCommonInputProps> = ({ isFieldValueValid, errors, touched, setFieldValue, values, handleBlur, t }) => {
	const [dialogType, setDialogType] = useState<DialogType>('');

	return (
		<div>
			<SeparateNumericInputField
				isFieldValueValid={isFieldValueValid}
				errors={errors}
				touched={touched}
				onBlur={handleBlur}
				setFieldValue={setFieldValue}
				name={'smsCode'}
				values={values}
				cyTestRef="sms-code"
				cyErrorRef="reg-validation-error"
			/>
			<SendCode
				isFieldValueValid={isFieldValueValid}
				errors={errors}
				touched={touched}
				values={values}
				setDialogType={setDialogType}
				cyTestRef="sending-sms-code"
			/>

			{dialogType === 'smsSent' && (
				<SuccessCard
					iconTitle={t('smsCodeSent')}
					onClose={() => setDialogType('')}
					cyDescriptionTestRef="popup-title"
					cyActionTextRef="popup-ok"
				/>
			)}
			{dialogType === 'error' && <ErrorCard iconTitle={t('smsCodeValidation')} onClose={() => setDialogType('')} />}
		</div>
	);
};

export default RegistrationStep7;
